<template>
  <PageLoader v-if="isLoading" />
  <Card :title="perimeter?.name" containerClass="mb-5" style="min-height: 70vh">
    <template #cardBody>
      <div class="d-flex flex-column flex-md-row justify-content-between mb-7">
        <ul class="nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-bold mb-3 mb-md-0">
          <li class="nav-item cursor-pointer" @click.prevent="toggleTab(tabs.USERS)">
            <a
                class="nav-link text-active-primary pb-4"
                :class="{ 'active': route.query.tab === tabs.USERS || !route.query.tab }"
                >{{ $t('access.userList') }}</a>
          </li>
          <li class="nav-item cursor-pointer" @click.prevent="toggleTab(tabs.GROUPS)">
            <a
                class="nav-link text-active-primary pb-4"
                :class="{ 'active': route.query.tab === tabs.GROUPS }"

            > {{ $t('access.groups') }} </a>
          </li>
        </ul>
      </div>
      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade show mh-500px scroll-y p-2" :class="{ 'active': route.query.tab === tabs.USERS || !route.query.tab }" :id="tabs.USERS" role="tabpanel">
          <div class="d-flex align-items-center justify-content-between mb-4">
            <RequiredText v-if="false" :text="$t('access.unsavedChangesWillBeLost')" />

            <div class="d-flex justify-content-center ms-auto">
              <Input
                  container-class="me-4 mb-2 mb-md-0"
                  inputClass="form-control form-control-sm"
                  name="input-search"
                  :isInputGroup="true"
                  :placeholder="$t('label.search')"
                  v-model="filter.users"
              >
                <template #rightAddon>
                    <span class="position-absolute border-0 bg-transparent end-0 top-50 translate-middle">
                      <i class="fa fa-search"></i>
                    </span>
                </template>
              </Input>
              <Button
                  btn-class="btn btn-sm btn-primary"
                  type="button"
                  icon-class="fa fa-user"
                  :btn-text="$t('button.add')"
                  @click.prevent="toggleModal('add_user_to_perimeter_modal')"
              />
            </div>
          </div>

          <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="user_datatable">
            <thead class="mb-5">
            <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
              <th  v-if="false" class="w-25px">
                <div class="form-check form-check-sm form-check-custom form-check-solid">
                  <input class="form-check-input" type="checkbox" value="1" data-kt-check="true" data-kt-check-target=".widget-9-check">
                </div>
              </th>
              <th class="min-w-100px">{{ $t('access.label.users') }}</th>
              <th class="min-w-100px text-center">{{ $t('access.label.accessRight') }}</th>
              <th class="min-w-100px text-center">{{ $t('access.label.accessMethods') }}</th>
              <th class="w-100px text-start">{{ $t('label.action') }}</th>
            </tr>
            </thead>

            <tbody v-if="filteredPerimeterUsers && filteredPerimeterUsers.length">
            <tr v-for="user in filteredPerimeterUsers" :key="user.id">
              <td v-if="false">
                <div class="form-check form-check-sm form-check-custom form-check-solid">
                  <input class="form-check-input widget-9-check" type="checkbox" value="1">
                </div>
              </td>
              <td>
                <a href="#" class="text-dark fw-bolder text-hover-primary fs-6">
                  {{ user?.user?.fullname }}
                  <span v-if="!user.is_user" class="badge badge-light-primary ms-1"> {{ $t('access.card.externalUser') }} </span>
                </a>
              </td>
              <td class="text-center">
                <span v-if="user.enabled" @click.prevent="toggleAuthorizeStatus(user)" :title="$t('access.configAccess.disableAccess')" class="badge badge-light-success badge-sm cursor-pointer"> {{ $t('access.label.accessGranted') }} </span>
                <span :title="$t('access.configAccess.enableAccess')" v-else @click.prevent="toggleAuthorizeStatus(user)"  class="badge badge-light-danger badge-sm cursor-pointer">{{ $t('access.label.accessDenied') }}</span>
              </td>
              <td class="text-center">
                <div class="d-flex justify-content-center flex-shrink-0">
                  <a v-if="user.access_methods && user.access_methods.length > 0" href="#"  class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 cursor-default" :title="$t('access.doorProcessNumber')">
                    <i class="fa"> {{ user.access_methods.length }} </i>
                  </a>
                </div>
              </td>
              <td>
                <div class="d-flex justify-content-end flex-shrink-0">
                  <a v-if="!hasRight(user.user_id) && user.is_user"
                     @click.prevent="assignRightAccessToDoor(user.user_id)"
                     class="btn btn-icon btn-bg-light btn-active-color-success btn-sm me-1"
                     :title="$t('access.assign_ring')">
                    <i class="fa fa-bell-slash fs-2"></i>
                  </a>

                  <a v-else-if="user.is_user"
                     @click.prevent="removeRightAccessToDoor(user.user_id)"
                     class="btn btn-icon btn-bg-light btn-active-color-danger btn-sm me-1"
                     :title="$t('access.revoke_ring')">
                    <i class="fa fa-bell fs-2"></i>
                  </a>

                  <a v-if="user.is_user" href="#" @click.prevent="toggleConfigModal(user)" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1" :title="$t('access.config')">
                    <span class="svg-icon svg-icon-3">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M17.5 11H6.5C4 11 2 9 2 6.5C2 4 4 2 6.5 2H17.5C20 2 22 4 22 6.5C22 9 20 11 17.5 11ZM15 6.5C15 7.9 16.1 9 17.5 9C18.9 9 20 7.9 20 6.5C20 5.1 18.9 4 17.5 4C16.1 4 15 5.1 15 6.5Z" fill="currentColor"></path>
                        <path opacity="0.3" d="M17.5 22H6.5C4 22 2 20 2 17.5C2 15 4 13 6.5 13H17.5C20 13 22 15 22 17.5C22 20 20 22 17.5 22ZM4 17.5C4 18.9 5.1 20 6.5 20C7.9 20 9 18.9 9 17.5C9 16.1 7.9 15 6.5 15C5.1 15 4 16.1 4 17.5Z" fill="currentColor"></path>
                      </svg>
                    </span>
                  </a>
                  <a href="#" @click.prevent="toggleShareConfigModal(user.id)" class="btn btn-icon btn-bg-light btn-active-color-warning btn-sm me-1" :title="$t('access.share')">
                    <i class="fa fa-share"></i>
                  </a>
                  <a href="#" @click.prevent="removeAccess(user.user_id)" class="btn btn-icon btn-bg-light btn-active-color-danger btn-sm me-1" :title="$t('button.delete')">
                    <i class="fa fa-trash-alt"></i>
                  </a>
                </div>
              </td>
            </tr>
            </tbody>
            <tbody v-else>
            <tr>
              <td colspan="5">
                <div class="d-flex align-items-center justify-content-center scroll-y p-2">
                  <div class="text-center">
                    <div class="fs-2 fw-bold text-gray-800 text-center mt-7">
                      {{ $t('access.configAccess.noUserFound') }}
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>

          </table>

        </div>
        <div class="tab-pane fade show mh-500px scroll-y p-2" :class="{ 'active': route.query.tab === tabs.GROUPS }" :id="tabs.GROUPS" role="tabpanel">
          <div class="d-flex align-items-center justify-content-between mb-4">
            <RequiredText v-if="false" :text="$t('access.unsavedChangesWillBeLost')" />

            <div class="d-flex justify-content-center ms-auto">
              <Input
                  container-class="me-4 mb-2 mb-md-0"
                  inputClass="form-control form-control-sm"
                  name="input-search"
                  :isInputGroup="true"
                  :placeholder="$t('label.search')"
                  v-model="filter.groups"
              >
                <template #rightAddon>
                    <span class="position-absolute border-0 bg-transparent end-0 top-50 translate-middle">
                      <i class="fa fa-search"></i>
                    </span>
                </template>
              </Input>
              <Button
                  btn-class="btn btn-sm btn-primary"
                  type="button"
                  icon-class="fa fa-user"
                  :btn-text="$t('button.add')"
                  @click.prevent="toggleModal('add_group_to_perimeter_modal')"
              />
            </div>
          </div>

          <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="group_datatable">
            <thead class="mb-5">
            <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
              <th  v-if="false" class="w-25px">
                <div class="form-check form-check-sm form-check-custom form-check-solid">
                  <input class="form-check-input" type="checkbox" value="1" data-kt-check="true" data-kt-check-target=".widget-9-check">
                </div>
              </th>
              <th class="min-w-100px">{{ $t('access.label.groups') }}</th>
              <th class="min-w-100px text-center">{{ $t('access.label.accessRight') }}</th>
              <th class="min-w-100px text-center">{{ $t('access.label.accessMethods') }}</th>
              <th class="w-100px text-start">{{ $t('label.action') }}</th>
            </tr>
            </thead>

            <tbody v-if="filteredPerimeterGroups && filteredPerimeterGroups.length">
            <tr v-for="group in filteredPerimeterGroups" :key="group.id">
              <td v-if="false">
                <div class="form-check form-check-sm form-check-custom form-check-solid">
                  <input class="form-check-input widget-9-check" type="checkbox" value="1">
                </div>
              </td>
              <td>
                <a href="#" class="text-dark fw-bolder text-hover-primary fs-6">
                  {{ group?.group_name }}
                </a>
              </td>
              <td class="text-center">
                <span v-if="group.enabled" @click.prevent="toggleAuthorizeStatus(group, true)" class="badge badge-light-success badge-sm cursor-pointer">
                  {{ $t('access.label.accessGranted') }}
                </span>
                <span v-else @click.prevent="toggleAuthorizeStatus(group, true)" class="badge badge-light-danger badge-sm cursor-pointer">
                   {{ $t('access.label.accessDenied') }}
                </span>
              </td>
              <td class="text-center">
                <div class="d-flex justify-content-center flex-shrink-0">
                  <a v-if="group.access_methods && group.access_methods.length > 0" href="#"  class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 cursor-default" :title="$t('access.doorProcessNumber')">
                    <i class="fa"> {{ group.access_methods.length }} </i>
                  </a>
                </div>
              </td>
              <td>
                <div class="d-flex justify-content-end flex-shrink-0">
                  <a href="#" @click.prevent="toggleConfigModal(group, true)" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                    <span class="svg-icon svg-icon-3">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M17.5 11H6.5C4 11 2 9 2 6.5C2 4 4 2 6.5 2H17.5C20 2 22 4 22 6.5C22 9 20 11 17.5 11ZM15 6.5C15 7.9 16.1 9 17.5 9C18.9 9 20 7.9 20 6.5C20 5.1 18.9 4 17.5 4C16.1 4 15 5.1 15 6.5Z" fill="currentColor"></path>
                        <path opacity="0.3" d="M17.5 22H6.5C4 22 2 20 2 17.5C2 15 4 13 6.5 13H17.5C20 13 22 15 22 17.5C22 20 20 22 17.5 22ZM4 17.5C4 18.9 5.1 20 6.5 20C7.9 20 9 18.9 9 17.5C9 16.1 7.9 15 6.5 15C5.1 15 4 16.1 4 17.5Z" fill="currentColor"></path>
                      </svg>
                    </span>
                  </a>
                  <a href="#" @click.prevent="toggleShareConfigModal(group.id)" class="btn btn-icon btn-bg-light btn-active-color-warning btn-sm me-1">
                    <i class="fa fa-share"></i>
                  </a>
                  <a href="#" @click.prevent="removeAccess(group.group_id, true)" class="btn btn-icon btn-bg-light btn-active-color-danger btn-sm me-1">
                    <i class="fa fa-trash-alt"></i>
                  </a>
                </div>
              </td>
            </tr>
            </tbody>
            <tbody v-else>
            <tr>
              <td colspan="5">
                <div class="d-flex align-items-center justify-content-center scroll-y p-2">
                  <div class="text-center">
                    <div class="fs-2 fw-bold text-gray-800 text-center mt-7">
                      {{ $t('access.configAccess.noGroupFound') }}
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>

          </table>
        </div>
      </div>
    </template>
    <template v-if="false" #cardFooter>
      <div class="d-flex justify-content-end align-items-center">
        <Button
            btn-class="btn btn-sm me-3"
            type="cancel"
            :btn-text="$t('button.cancel')"
        />
        <Button
            btn-class="btn btn-sm btn-primary"
            type="submit"
            :btn-text="$t('button.save')"
        />
      </div>
    </template>
  </Card>
  <AddUserOrGroupToPerimeterModal
      id="add_user_to_perimeter_modal"
      :perimeter="perimeter.id"
      :is-door="isDoor"
      :oldData="perimeterUsersIds"
      @callback="loadUsersDetail"
  />
  <AddUserOrGroupToPerimeterModal
      id="add_group_to_perimeter_modal"
      :perimeter="perimeter.id"
      :is-door="isDoor"
      :forUser="false"
      :oldData="perimeterGroupsIds"
      @callback="loadGroupDetail"
  />
  <UserAccessConfigModal id="perimeter_user_or_group_config_modal" :data="formEditData" @callback="loadSelectedDetail"/>
  <ShareConfigModal id="share_user_or_group_config_modal" :data="formShareData" @callback="reloadTreeData"/>
</template>

<script setup>

import Button from "@/components/Button.vue";
import Card from "@/Modules/CRM/components/Card.vue";
import RequiredText from "@/components/RequiredText.vue";

import {computed, defineProps, onMounted, reactive, ref, watch} from 'vue'
import {useLocales} from "@/composables/locales";
import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";
import AddUserOrGroupToPerimeterModal
  from "@/Modules/Access/views/Config/components/AddUserOrGroupToPerimeterModal.vue";
import {useAccessMethodUtils} from "@/Modules/Access/composables/accessMethodUtils";
import UserAccessConfigModal from "@/Modules/Access/views/Config/components/UserAccessConfigModal.vue";
import Input from "@/components/Input.vue";
import PageLoader from "@/components/PageLoader.vue";
import {useSwal} from "@/composables/useSwal";
import ShareConfigModal from "@/Modules/Access/views/Config/components/ShareConfigModal.vue";

const {showSwal} = useSwal()
const route = useRoute()
const router = useRouter()
const store = useStore()
const {locale, datatableLocaleUrl} = useLocales()
const { getAccessMethod } = useAccessMethodUtils()

const props = defineProps({
  perimeter: {
    type: Object,
    required: true
  }
})

const isLoading = ref(false)
const query = ref({
  status: '',
})
const perimeterUsers = ref([])
const perimeterGroups = ref([])
const tabs = reactive({
  USERS: 'users_tab',
  GROUPS: 'groups_tab'
})
const formEditData = ref({
  id: '',
  name: '',
  perimeter: '',
  door: '',
  user: '',
  group: '',
  datetime_frames: [],
  hours: {
    days: {}
  },
  enabled: false
})
const formShareData = ref({
  from_id: '',
  to_id: '',
  user_id: '',
  type: ''
})
const filter = reactive({
  groups: '',
  users: ''
})

const userAssignRightToDoor = computed(() => store.getters['perimeters/getUserAssignRight'] || { users: [] });



const userAssignRightToDoorIds = computed(() => {
  const users = userAssignRightToDoor.value?.users || [];
  return Array.isArray(users) ? users.map(u => u.id) : [];
});


const hasRight = (userId) => userAssignRightToDoorIds.value.includes(userId);




const isDoor = computed(() => !!props.perimeter?.isDoor)
const filteredPerimeterUsers = computed(() => {
  if (!filter.users) return perimeterUsers.value;
  return perimeterUsers.value.filter(user => user?.user?.fullname.toLowerCase().includes(filter.users.toLowerCase()));
});
const filteredPerimeterGroups = computed(() => {
  if (!filter.groups) return perimeterGroups.value;
  return perimeterGroups.value.filter(group => group?.group_name.toLowerCase().includes(filter.groups.toLowerCase()));
});
const perimeterUsersIds = computed(() => perimeterUsers.value?.map(g => g.user_id) || [])
const perimeterGroupsIds = computed(() => perimeterGroups.value?.map(g => g.group_id) || [])


watch(() => route.query.tab, () => {
  loadSelectedDetail()
})

watch(() => props.perimeter, (value, oldValue) => {
  if(value.id !== oldValue.id) {
    perimeterUsers.value = null
    perimeterGroups.value = null
    loadSelectedDetail()
    loadUserAssignRightToDoor()
    filter.users = ''
    filter.groups = ''
  }

}, { deep: true })

watch(() => [perimeterGroups.value, perimeterUsers.value], () => {
  if(formEditData.value.id) {
    let data = perimeterUsers.value?.find(u => u.id === formEditData.value.id) || perimeterGroups.value?.find(g => g.id === formEditData.value.id)
    if(data) {
      formEditData.value = {
        id: data?.id || data?.group_id,
        name: data?.user?.fullname || data?.group_name,
        isDoor: isDoor.value,
        user: data?.user_id || null,
        group: data?.group_id || null,
        door: isDoor.value ? props.perimeter.id : null,
        perimeter: !isDoor.value ? props.perimeter.id : null,
        enabled: !!data?.enabled,
        accessMethods: [...data?.access_methods],
        hours: data?.date_frames ? Object.entries(data?.date_frames).map(([day_id, hours]) => ({
          day_id,
          hours
        })) : []
      }
    }
  }
})

function loadSelectedDetail() {
  if (route.query.tab === tabs.USERS || !route.query.tab) {
    loadUsersDetail()
  } else {
    loadGroupDetail()
  }
}

function loadUsersDetail() {
  isLoading.value = true

  let endPoint = isDoor.value ? 'doors/getDoorUserAccess' : 'perimeters/getPerimeterUserAccess'

  store.dispatch(endPoint, props.perimeter.id)
      .then((res) => {
        perimeterUsers.value = res.data?.data
      })
      .catch()
      .finally(() => isLoading.value = false)
}

function loadGroupDetail() {
  isLoading.value = true

  let endPoint = isDoor.value ? 'doors/getDoorGroupAccess' : 'perimeters/getPerimeterGroupAccess'

  store.dispatch(endPoint, props.perimeter.id)
      .then((res) => {
        perimeterGroups.value = res.data?.groups
      })
      .catch()
      .finally(() => isLoading.value = false)
}

function toggleTab(tabId){
  router.replace({ query: { ...route.query, tab: tabId } });
}

function toggleModal(modalId) {
  $('#'+modalId).modal('toggle')
}

function toggleConfigModal(data, isGroup = false) {
  formEditData.value = {
    id: data?.id || data?.group_id,
    name: data?.user?.fullname || data?.group_name,
    isDoor: isDoor.value,
    user: isGroup ? null : data?.user_id,
    group: isGroup ? data?.group_id : null,
    door: isDoor.value ? props.perimeter.id : null,
    perimeter: !isDoor.value ? props.perimeter.id : null,
    enabled: !!data?.enabled,
    accessMethods: [...data?.access_methods],
    hours: data?.date_frames ? Object.entries(data?.date_frames).map(([day_id, hours]) => ({
      day_id,
      hours
    })) : []
  }
  $('#perimeter_user_or_group_config_modal').modal('toggle')
}
function toggleShareConfigModal(id) {
  formShareData.value = {
    id,
    type: '',
    to_id: ''
  }
  $('#share_user_or_group_config_modal').modal('toggle')
}

function sortMethods (methods){
  if (!methods?.length) return [];
  return [...methods].sort((a, b) => a.order - b.order)
}
function toggleAuthorizeStatus(data, isGroup = false) {
  isLoading.value = true
  let formData = {
    perimeters: !isDoor.value ? [props.perimeter.id] : [],
    doors: isDoor.value ? [props.perimeter.id] : [],
    users: isGroup ? [] : [data?.user_id],
    groups: isGroup ? [data?.group_id] : [],
    enabled: !data?.enabled
  }

  store.dispatch('access/setAccess', formData)
      .then((response) => {
        loadSelectedDetail()
        window.toastr['success'](i18n.global.t('notification.config_updated'))
      })
      .catch(() =>  isLoading.value = false)
}

function removeAccess(id, isGroup = false) {
  showSwal(
      '',
      i18n.global.t('access.swal.access_deleted'),
  ).then( async (result) => {
    if (result.value) {
      isLoading.value = true
      let formData = {
        perimeter: !isDoor.value ? props.perimeter.id : null,
        door: isDoor.value ? props.perimeter.id : null,
        user: isGroup ? null : id,
        group: isGroup ? id : null,
      }

      store.dispatch('access/removeAccess', formData)
          .then((response) => {
            loadUserAssignRightToDoor()
            loadSelectedDetail()
            window.toastr['success'](i18n.global.t('notification.revoke_ring'))
          })
          .catch(() =>  isLoading.value = false)
    }
  })

}

function assignRightAccessToDoor(id) {
  showSwal(
      '',
      i18n.global.t('access.swal.assign_ring'),
  ).then(async (result) => {
    if (result.value) {
      isLoading.value = true

      let formData = {
        door_id: props.perimeter.id,
        user_id: [id],
      }

      store.dispatch('perimeters/assignRightAccessToDoor', formData)
          .then((response) => {
            loadUserAssignRightToDoor()
            loadSelectedDetail()
            window.toastr['success'](i18n.global.t('notification.assign_ring'))
          })
          .finally(() => {
            isLoading.value = false
          })
    }
  })
}

function removeRightAccessToDoor(id) {
  showSwal(
      '',
      i18n.global.t('access.swal.revoke_ring')
  ).then(async (result) => {
    if (result.value) {
      isLoading.value = true

      let formData = {
        door_id: props.perimeter.id,
        user_id: id,
      }

      store.dispatch('perimeters/removeRightAccessToDoor', formData)
          .then((response) => {
            loadUserAssignRightToDoor()
            loadSelectedDetail()
            window.toastr['success'](i18n.global.t('notification.revoke_ring'))
          })
          .finally(() => {
            isLoading.value = false
          })
    }
  })
}



function reloadTreeData() {
  store.dispatch('perimeters/loadMainPerimeters')
  store.dispatch("perimeters/loadPerimeters")
}


function loadUserAssignRightToDoor(){
  store.dispatch('perimeters/loadUserAssignRightToDoor', props.perimeter.id)
}


onMounted(() => {
  loadSelectedDetail()
  loadUserAssignRightToDoor()
})

</script>

<style scoped>

</style>